import "./Paragraph.scss";

interface ParagraphParams {
    children: React.ReactNode;
}

export const Paragraph = ({ children }: ParagraphParams) => {
    return <p className='Paragraph'>{children}</p>;
}